import { FICTION_GENRES } from "../data/constants";

/**
 * 서재를 한 문장으로 요약한다.
 *
 * 감정 좌표는 MUROO 만 가진 데이터다. 별점으로는 "어둡고 격렬한 소설을
 * 읽는 사람" 을 말할 수 없다.
 *
 * 좌표 축이 장르마다 다르므로 소설류와 비소설을 따로 평균한다.
 * 섞어서 평균하면 '밝음' 과 '가벼움' 을 더한 값이 나오는데, 그건 둘 다 아니다.
 */

/** 이보다 적은 좌표로는 취향을 단정하지 않는다. 2권으로 사람을 말하면 틀린다. */
const MIN_POINTS = 5;

// 앞말은 연결형으로 둔다. "어두운 차분한 소설" 처럼 형용사를 둘 나란히
// 붙이면 한국어가 아니다. "어둡고 차분한 소설" 이 된다.
const X = { fiction: ["밝고", "어둡고"], nonfiction: ["가볍고", "무겁고"] };
const Y = { fiction: ["차분한", "격렬한"], nonfiction: ["실용적인", "사색적인"] };
const NOUN = { fiction: "소설", nonfiction: "책" };

/**
 * @param {object} user       프로필 (bookIds 포함)
 * @param {Array}  allBooks   전체 책 (emotions, genre 포함)
 * @returns {{sentence:string, basis:string}|null} 근거가 모자라면 null
 */
export default function tasteSummary(user, allBooks) {
  if (!user?.id) return null;
  const mine = new Set(user.bookIds || []);
  if (!mine.size) return null;

  const pts = { fiction: [], nonfiction: [] };
  const genres = {};
  let completed = 0;

  for (const b of allBooks || []) {
    if (!mine.has(b.id)) continue;
    if (b.genre && b.genre !== "기타") genres[b.genre] = (genres[b.genre] || 0) + 1;
    if (b.completedBy?.[user.id]) completed++;
    const e = b.emotions?.[user.id];
    if (!e) continue;
    pts[FICTION_GENRES.includes(b.genre) ? "fiction" : "nonfiction"].push(e);
  }

  // 좌표가 많은 쪽으로 말한다. 둘 다 모자라면 아무 말도 하지 않는다.
  const kind = pts.fiction.length >= pts.nonfiction.length ? "fiction" : "nonfiction";
  const use = pts[kind];
  if (use.length < MIN_POINTS) return null;

  const avg = (k) => use.reduce((s, e) => s + e[k], 0) / use.length;
  const x = X[kind][avg("bright") >= 50 ? 1 : 0];
  const y = Y[kind][avg("calm") >= 50 ? 1 : 0];

  // 한 권뿐인 장르는 근거가 아니다. '세계문학 1' 은 취향이라기엔 얇다.
  const top = Object.entries(genres)
    .filter(([, c]) => c >= 2)
    .sort((a, b) => b[1] - a[1] || a[0].localeCompare(b[0]))
    .slice(0, 2)
    .map(([g, c]) => `${g} ${c}`);

  const basis = [...top, `${mine.size}권 중 ${completed}권 완독`].join(" · ");

  return { sentence: `${x} ${y} ${NOUN[kind]}을 주로 읽어요`, basis };
}
